import { gql } from "@apollo/client";

export const blacklistableIdentifierFragment = gql`
  fragment BlacklistableIdentifierFragment on BlacklistableCaseIdentifier {
    element {
      id
      name
      typeCode
    }
    belongsToCurrentCase
    identifier {
      id
      schemaIdentifier {
        code
      }
      value
      identifierType {
        name
        code
      }
    }
    linkedCases {
      id
    }
    blacklist {
      name
      code
    }
  }
`;
